import { useCallback, useMemo } from 'react';
import { useApplicationRootConfiguration } from '../../application-root-configuration.provider';

const useConfiguration = () => useApplicationRootConfiguration().getSection('internationalization-configuration');

/**
 * Hooks to get the internationalization configuration from the application root configuration.
 * @returns {
 *  configuration: the internationalization configuration,
 *  isRegion: function to return if the configuration region is equal to the given region (the params)
 * }
 */
const useInternationalizationConfiguration = () => {
  const configuration = useConfiguration();
  const isRegion = useCallback((region) => configuration.region === region, [configuration.region]);
  return useMemo(() => ({
    configuration,
    isRegion,
  }), [configuration, isRegion]);
};

export default useInternationalizationConfiguration;
